import { useSelector } from 'react-redux';

import { RootStateWithAuth } from '../types';

export const useAuth = () => useSelector((state: RootStateWithAuth) => state.auth);
